import { cn } from "../v2/utils";
import { jsx as _jsx } from "react/jsx-runtime";
var Count = function Count(_ref) {
  var count = _ref.count,
    dataTestId = _ref['data-testid'],
    selected = _ref.selected,
    disabled = _ref.disabled,
    styleSelectAround = _ref.styleSelectAround;
  return /*#__PURE__*/_jsx("div", {
    className: cn(' tw-ml-1 tw-px-0.8 tw-rounded-0.4', selected ? 'tw-bg-primary-light-200 dark:tw-bg-secondary-light-200' : 'tw-bg-neutral-light-400 dark:tw-bg-neutral-dark-600', {
      '!tw-bg-neutral-light-100': styleSelectAround && selected
    }),
    "data-testid": dataTestId,
    children: /*#__PURE__*/_jsx("span", {
      className: cn({
        'dark:tw-text-neutral-light-800': disabled,
        'tw-text-neutral-light-800': styleSelectAround && !selected,
        'dark:tw-text-elevation-dark-00': selected
      }),
      children: count
    })
  });
};
export default Count;